import { FunctionComponent } from 'react';
import Modal from '../../Utility/Modal/Modal';
import Box from '../../Layout/Box/Box';
import Button from '../../Input/Button/Button';
import styles from './TermsAndConditions.module.scss';
import Term from '../../Text/Term/Term';

export type TermsAndConditionsProps = {
  isVisible?: boolean;
  country: string;
  onAgree: (e: boolean) => void;
  onDisagree: (e: boolean) => void;
};

type FC = FunctionComponent<TermsAndConditionsProps>;

const TermsAndConditions: FC = ({ isVisible = true, country, onAgree, onDisagree }: TermsAndConditionsProps) => (
  <Modal isVisible={isVisible} enableBgClick={false}>
    <div className={styles.container}>
      <h1>Pre-authorized Debit Agreement</h1>
      <Term term="By proceeding, you accept this Pre-Authorized Debit Agreement and authorize VoPay International Inc. to debit the selected payment methods for any amount owed for charges arising from the use of services and/or purchase of products." />
      {country === 'CA' && (
        <Box pt="sm">
          <Term
            term={
              <a href="https://vopay.com/ca/legal/pad/" target="_blank" rel="noreferrer">
                Open this agreement in a new window.
              </a>
            }
          />
        </Box>
      )}
      {country === 'US' && (
        <Box pt="sm">
          <Term
            term={
              <a href="https://vopay.com/ca/legal/ach-debit-agreement/" target="_blank" rel="noreferrer">
                Open this agreement in a new window.
              </a>
            }
          />
        </Box>
      )}
      <div className={styles.ButtonBar}>
        <Button
          id="pre-authorized-debit-accept"
          color="dark"
          round
          bold
          noShadow
          size="xlg"
          label="Accept and Continue"
          width="100%"
          onClick={() => {
            onAgree(true);
          }}
        />
      </div>

      <div className={styles.CrossContainer}>
        <Button
          id='pre-authorized-debit-close"'
          color="secondary"
          label=""
          iconLocation="center"
          icon="cross"
          iconSize="md"
          iconWidth="17px"
          background="none"
          noShadow
          onClick={() => {
            onDisagree(true);
          }}
        />
      </div>
    </div>
  </Modal>
);
export default TermsAndConditions;
